export default "/imgs/tag/chairman.svg"